
import { Link } from 'react-router-dom';

export default function UrgencyBanner() {
  return (
    <section className="relative overflow-hidden">
      {/* Scrolling urgency strip */}
      <div className="bg-gradient-to-r from-red-600 via-orange-500 to-red-600 py-3 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-12">
          {[...Array(6)].map((_, i) => (
            <span key={i} className="text-white font-bold text-sm uppercase tracking-wider flex items-center gap-3">
              <i className="ri-flashlight-fill"></i>
              Hurry — Limited Licences at This Price
              <i className="ri-flashlight-fill"></i>
              Up to 60% Off Ends Soon
            </span>
          ))}
        </div>
      </div>

      {/* Final CTA */}
      <div className="bg-slate-950 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white font-display mb-6 leading-tight">
            Don&apos;t Let This<br />
            <span className="bg-gradient-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent">Opportunity Slip Away</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-xl mx-auto mb-10">
            Join 10,000+ Australian tradies already saving time and money with MtaPlannerPro. These deals won&apos;t last.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#flash-deals"
              className="px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg font-semibold text-lg hover:shadow-lg hover:shadow-amber-500/30 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-cart-2-line mr-2"></i>
              Grab a Deal Now
            </a>
            <Link
              to="/demo"
              className="px-8 py-4 bg-white/10 border border-white/20 text-white rounded-lg font-semibold text-lg hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line mr-2"></i>
              Watch Demo First
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
